import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseTooltip } from 'shared/abstract/base-tooltip';

@Component({
    selector: 'app-image-tracker-asset-cell-tooltip',
    imports: [TranslatePipe],
    templateUrl: './image-tracker-asset-cell-tooltip.component.html',
    styleUrl: './image-tracker-asset-cell-tooltip.component.scss',
})
export class ImageTrackerAssetCellTooltipComponent extends BaseTooltip {
    public override data: any;
}
